var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',{attrs:{"title":""}},[_c('div',[_c('vue-element-loading',{attrs:{"active":_vm.loading,"color":"#00cca2","spinner":"spinner"}}),_c('ve-ring',{attrs:{"data":_vm.contact_type_data,"settings":_vm.chartSettings}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }